import React, { useState, useEffect } from 'react';
import './App.css';
import ContactForm from './ContactForm';
import Counter from './Counter';

const SoftParkingLanding = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openFAQ, setOpenFAQ] = useState(null);
  const [showContactForm, setShowContactForm] = useState(false);

  const faqs = [
    {
      question: "Cât de rapid putem implementa SoftParking?",
      answer: "Majoritatea instalărilor sunt finalizate în 3-5 zile. Sistemul nostru se integrează ușor cu infrastructura existentă, iar echipa noastră oferă suport complet pentru implementare."
    },
    {
      question: "Există un cost de implementare a SoftParking?",
      answer: "Da, implementarea presupune un cost unic, plătit o singură dată la început. Acesta acoperă configurarea platformei și adaptarea la specificul locației tale. Costul exact este stabilit în funcție de gradul de dificultate și complexitatea implementării – fără costuri ascunse."
    },
    {
      question: "Ce suport oferim clienților noștri?",
      answer: "Oferim suport prin telefon, chat și email."
    },
    {
      question: "SoftParking se poate adapta la creșterea afacerii?",
      answer: "Absolut! Arhitectura noastră cloud gestionează de la o singură locație până la operațiuni enterprise cu mii de locuri de parcare pe multiple facilități."
    },
    {
      question: "Există contract pe termen lung?",
      answer: "Nu sunt necesare contracte pe termen lung. Suntem încrezători în valoarea produsului nostru și preferăm să ne câștigăm clienții prin servicii excepționale."
    }
  ];

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <>
      <ContactForm open={showContactForm} onClose={() => setShowContactForm(false)} />
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-black/20 backdrop-blur-md z-50 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center space-x-2">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-xl flex items-center justify-center shadow-lg" style={{cursor: 'pointer'}} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                <span className="text-white font-bold text-xl">SP</span>
              </div>
              <span className="text-white font-bold text-2xl" style={{cursor: 'pointer'}} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>SoftParking</span>
            </div>
            
            <div className="hidden md:flex space-x-8">
              <button onClick={() => scrollToSection('features')} className="text-white/80 hover:text-white transition-colors">Funcționalități</button>
              <button onClick={() => scrollToSection('dashboard')} className="text-white/80 hover:text-white transition-colors">Dashboard</button>
              <button onClick={() => scrollToSection('pricing')} className="text-white/80 hover:text-white transition-colors">Prețuri</button>
              <button onClick={() => scrollToSection('faq')} className="text-white/80 hover:text-white transition-colors">FAQ</button>
            </div>

            <div className="hidden md:flex space-x-4">
              <button className="text-white/80 hover:text-white transition-colors" onClick={() => window.location.href = 'https://softparking.ro/login.html'}>Login</button>
              <button className="bg-gradient-to-r from-blue-500 to-cyan-600 text-white px-6 py-2 rounded-lg hover:from-blue-600 hover:to-cyan-700 transition-all transform hover:scale-105" onClick={() => window.location.href = '/login.html?email=demo@softparking.ro&password=123456'}>
              DEMO GRATUIT
              </button>
            </div>

            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden text-white"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="fixed inset-0 bg-black/95 backdrop-blur-md z-40 md:hidden">
          <div className="flex flex-col items-center justify-center h-full space-y-8">
            <button onClick={() => scrollToSection('features')} className="text-white text-xl">Funcționalități</button>
            <button onClick={() => scrollToSection('dashboard')} className="text-white text-xl">Dashboard</button>
            <button onClick={() => scrollToSection('pricing')} className="text-white text-xl">Prețuri</button>
            <button onClick={() => scrollToSection('faq')} className="text-white text-xl">FAQ</button>
            <div className="flex flex-col items-center gap-4 w-full">
              <button className="bg-gradient-to-r from-blue-500 to-cyan-600 text-white px-8 py-3 rounded-lg text-xl w-[200px]" onClick={() => window.location.href = '/login.html?email=demo@softparking.ro&password=123456'}>
                DEMO Gratuit
              </button>
              <button className="bg-gradient-to-r from-cyan-600 to-blue-500 text-white px-8 py-3 rounded-lg text-xl w-[200px]" onClick={() => window.location.href = 'https://softparking.ro/login.html'}>
                Login
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 to-cyan-900/20"></div>
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-10"
          style={{
            backgroundImage: 'url(https://images.pexels.com/photos/63294/autos-technology-vw-multi-storey-car-park-63294.jpeg)'
          }}
        ></div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
              Sistemul de
              <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent"> Rezervări </span>
              care transformă parcarea
            </h1>
            <p className="text-xl md:text-2xl text-white/80 mb-8 leading-relaxed">
              SoftParking oferă operatorilor și managerilor o platformă completă pentru gestionarea rezervărilor, 
              cu dashboard în timp real, raportare avansată și control total asupra operațiunilor de parcare.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button className="border-2 border-white/20 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:bg-white/10 transition-all backdrop-blur-sm" onClick={() => window.location.href = '/login.html?email=demo@softparking.ro&password=123456'}>
                Vezi DEMO
              </button>
              <button className="bg-gradient-to-r from-blue-500 to-cyan-600 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:from-blue-600 hover:to-cyan-700 transition-all transform hover:scale-105 shadow-2xl" onClick={() => setShowContactForm(true)}>
                Contactează-ne
              </button>
            </div>
            <div className="mt-12 flex justify-center items-center space-x-8 text-white/60">
              <div className="text-center">
                <div className="text-2xl font-bold text-white"><Counter end={70} /></div>
                <div className="text-sm">Timp economisit</div>
                </div>
                <div className="w-px h-12 bg-white/20"></div>
                <div className="text-center">
                <div className="text-2xl font-bold text-white"><Counter end={99} /></div>
                <div className="text-sm">Mai puține erori</div>
                </div>
                <div className="w-px h-12 bg-white/20"></div>
                <div className="text-center">
                <div className="text-2xl font-bold text-white"><Counter end={100} /></div>
                <div className="text-sm">Rezervări digitalizate</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-20 bg-gradient-to-br from-slate-800 to-blue-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Funcționalități
              <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent"> complete </span>
              pentru operatori profesioniști
            </h2>
            <p className="text-xl text-white/70 max-w-3xl mx-auto">
              Tot ce ai nevoie pentru a gestiona eficient rezervările de parcare, de la intrări și ieșiri până la raportare avansată.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: "📊",
                title: "Dashboard în timp real",
                description: "KPI-uri live: venituri zilnice, ocupare, rezervări noi, și venit lunar estimat. Toate datele importante într-o privire."
              },
              {
                icon: "🎯",
                title: "Gestionare rezervări",
                description: "Vizualizare, adăugare, modificare, confirmare și anulare rezervări cu câteva click-uri. Interfață intuitivă pentru operatori."
              },
              {
                icon: "🔄",
                title: "Fluxuri automatizate",
                description: "Urmărire automată intrări/ieșiri, confirmare rezervări, procesare plăți și notificări pentru toate acțiunile importante."
              },
              {
                icon: "📱",
                title: "Interfață mobilă",
                description: "Aplicație optimizată perfect pentru smartphone și tabletă. Gestionează parcarea de oriunde, oricând."
              },
              {
                icon: "📈",
                title: "Raportare avansată",
                description: "Export XML, analize detaliate, statistici venituri, și rapoarte personalizabile pentru manageri și operatori."
              },
              {
                icon: "🔒",
                title: "Securitate & control",
                description: "Sistem de autentificare sigur, roluri utilizator (admin/agent), sesiuni automate și backup complet al datelor."
              }
            ].map((feature, index) => (
              <div key={index} className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:border-white/20 transition-all transform hover:scale-105">
                <div className="text-4xl mb-4">{feature.icon}</div>
                <h3 className="text-xl font-bold text-white mb-4">{feature.title}</h3>
                <p className="text-white/70 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Dashboard Preview Section */}
      <section id="dashboard" className="py-20 bg-gradient-to-br from-blue-900 to-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Dashboard-ul tău
              <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent"> de control </span>
            </h2>
            <p className="text-xl text-white/70 max-w-3xl mx-auto">
              Interfață centralizată cu toate informațiile critice pentru operațiunile tale de parcare
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div 
              className="relative rounded-3xl overflow-hidden shadow-2xl"
              style={{
                backgroundImage: 'url(https://images.unsplash.com/photo-1506521781263-d8422e82f27a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxzbWFydCUyMHBhcmtpbmd8ZW58MHx8fHwxNzUwMzU4MzEwfDA&ixlib=rb-4.1.0&q=85)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '500px'
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-blue-900/80 to-cyan-900/80 p-8 flex flex-col justify-center">
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-4">
                  <h3 className="text-white font-bold text-lg mb-2">KPI-uri Live</h3>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="text-center">
                      <div className="text-2xl font-bold text-cyan-400">2,450 RON</div>
                      <div className="text-white/70 text-sm">Venit Azi</div>
                    </div>
                    <div className="text-center">
                      <div className="text-2xl font-bold text-blue-400">85%</div>
                      <div className="text-white/70 text-sm">Ocupare</div>
                    </div>
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
                  <h3 className="text-white font-bold text-lg mb-2">Rezervări Noi</h3>
                  <div className="text-3xl font-bold text-green-400">12</div>
                  <div className="text-white/70 text-sm">În ultimele 2 ore</div>
                </div>
              </div>
            </div>

            <div className="space-y-8">
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
                <h3 className="text-2xl font-bold text-white mb-4">🚗 Rezervări</h3>
                <p className="text-white/70 mb-4">
                  Navigare rapidă între rezervări noi, intrări, ieșiri, anulate și finalizate. 
                  Căutare instant după ID sau cuvânt cheie.
                </p>
                <div className="flex space-x-2">
                  <span className="bg-blue-500/20 text-blue-300 px-3 py-1 rounded-full text-sm">Noi: 12</span>
                  <span className="bg-green-500/20 text-green-300 px-3 py-1 rounded-full text-sm">Intrări: 8</span>
                  <span className="bg-orange-500/20 text-orange-300 px-3 py-1 rounded-full text-sm">Ieșiri: 15</span>
                </div>
              </div>

              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
                <h3 className="text-2xl font-bold text-white mb-4">⏰ Intrări viitoare</h3>
                <p className="text-white/70 mb-4">
                  Următoarele 10 intrări programate în următoarele 36 de ore, 
                  cu detalii complete și posibilitate de confirmare rapidă.
                </p>
                <div className="text-cyan-400 font-semibold">Următoarea: 14:30 - (B-123-ABC)</div>
              </div>

              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
                <h3 className="text-2xl font-bold text-white mb-4">📊 Export & rapoarte</h3>
                <p className="text-white/70 mb-4">
                  Export XML pentru rezervări, rapoarte personalizabile și 
                  analize detaliate pentru optimizarea operațiunilor.
                </p>
                <button className="bg-gradient-to-r from-blue-500 to-cyan-600 text-white px-4 py-2 rounded-lg text-sm hover:from-blue-600 hover:to-cyan-700 transition-all" onClick={() => window.location.href = '/login.html?email=demo@softparking.ro&password=123456'}>
                  Vezi DEMO Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing/CTA Section */}
      <section id="pricing" className="py-20 bg-gradient-to-br from-blue-900 to-cyan-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              🅿️ SoftParking – Plan de Tarifare
            </h2>
          </div>

          {/* 1️⃣ Acces platformă */}
          <div className="mb-10 bg-white/5 rounded-2xl p-6 border border-white/10">
            <h3 className="text-2xl font-bold text-white mb-2">1️⃣ Acces platformă (abonament unic)</h3>
            <p className="text-white/80 mb-2">
              <span className="font-semibold">🔒 Toți clienții, indiferent de plan, beneficiază de acces complet la platformă.</span><br/>
              Nu există limitări de funcționalitate între lunar și anual.
            </p>
          </div>

          {/* 2️⃣ Planuri de tarifare */}
          <div className="mb-10 bg-white/5 rounded-2xl p-6 border border-white/10">
            <h3 className="text-2xl font-bold text-white mb-4">2️⃣ Planuri de tarifare</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-blue-900/40 rounded-xl p-6 border border-blue-400/30">
                <h4 className="text-xl font-bold text-white mb-2">Client lunar</h4>
                <div className="text-3xl font-bold text-cyan-400 mb-2">€130/lună</div>
                <div className="text-white/80 mb-2">+ <span className="font-semibold">€200 implementare</span></div>
                <ul className="text-white/70 list-disc ml-6 mb-2">
                  <li>Acces platformă</li>
                  <li>Pagină white-label (setup plătit separat)</li>
                </ul>
              </div>
              <div className="bg-cyan-900/40 rounded-xl p-6 border border-cyan-400/30">
                <h4 className="text-xl font-bold text-white mb-2">Client anual</h4>
                <div className="text-3xl font-bold text-cyan-400 mb-2">€100/lună</div>
                {/* <div className="text-white/80 mb-2">(plată anuală: <span className="font-semibold">€1.200</span>)</div> */}
                <ul className="text-white/70 list-disc ml-6 mb-2">
                  <li>Acces platformă</li>
                  <li>Pagină white-label cu <span className="font-semibold">implementare gratuită</span></li>
                </ul>
              </div>
              <div className="bg-green-900/40 rounded-xl p-6 border border-green-400/30">
                <h4 className="text-xl font-bold text-white mb-2">Procentual</h4>
                <div className="text-3xl font-bold text-cyan-400 mb-2">1% din rezervările confirmate</div>
                <ul className="text-white/70 list-disc ml-6 mb-2">
                  <li>Acces platformă</li>
                  <li>Pagină white-label cu <span className="font-semibold">implementare gratuită</span></li>
                </ul>
              </div>
            </div>
          </div>

          {/* 3️⃣ Pagina White-Label */}
          <div className="mb-10 bg-white/5 rounded-2xl p-6 border border-white/10">
            <h3 className="text-2xl font-bold text-white mb-2">3️⃣ Pagina White-Label – Formular de rezervare</h3>
            <p className="text-white/80 mb-2">
              <span className="font-semibold">Formularul de rezervare white-label</span> este o pagină personalizată (logo, culori, domeniu/subdomeniu), găzduită de SoftParking și accesată prin redirect din site-ul clientului, sau gazduita direct pe site-ul clientului.
            </p>
            <ul className="text-white/70 list-disc ml-6 mb-2">
              <li>Este inclusă în ambele planuri, cu următoarele condiții:</li>
              <li><span className="font-semibold">Client lunar</span>: plătește implementarea (<span className="font-semibold">€200 setup unic</span>)</li>
              <li><span className="font-semibold">Client anual</span>: setup <span className="font-semibold">gratuit</span></li>
              <li><span className="font-semibold">Procentual</span>: setup <span className="font-semibold">gratuit</span></li>
            </ul>
          </div>

          
          <div className="text-center mt-12">
            <button className="bg-gradient-to-r from-blue-500 to-cyan-600 text-white px-8 py-4 rounded-xl font-semibold hover:from-blue-600 hover:to-cyan-700 transition-all transform hover:scale-105 shadow-2xl" onClick={() => setShowContactForm(true)}>
              Solicită ofertă sau demo
            </button>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-20 bg-gradient-to-br from-slate-900 to-blue-900">
        <div 
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1610030181087-540017dc9d61?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxzbWFydCUyMHBhcmtpbmd8ZW58MHx8fHwxNzUwMzU4MzEwfDA&ixlib=rb-4.1.0&q=85)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Întrebări
              <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent"> frecvente </span>
            </h2>
            <p className="text-xl text-white/70">
              Tot ce trebuie să știi despre SoftParking și serviciile noastre
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 overflow-hidden">
                <button
                  onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                  className="w-full p-6 text-left flex justify-between items-center text-white hover:bg-white/5 transition-all"
                >
                  <span className="font-semibold text-lg">{faq.question}</span>
                  <svg 
                    className={`w-6 h-6 transition-transform ${openFAQ === index ? 'rotate-180' : ''}`}
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {openFAQ === index && (
                  <div className="px-6 pb-6 text-white/80 leading-relaxed">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <p className="text-white/60 mb-4">Mai ai întrebări?</p>
            <button className="bg-gradient-to-r from-blue-500 to-cyan-600 text-white px-8 py-3 rounded-xl font-semibold hover:from-blue-600 hover:to-cyan-700 transition-all transform hover:scale-105" onClick={() => setShowContactForm(true)}>
              Contactează-ne
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black/40 backdrop-blur-sm border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-xl flex items-center justify-center">
                  <span className="text-white font-bold text-xl">SP</span>
                </div>
                <span className="text-white font-bold text-2xl">SoftParking</span>
              </div>
              <p className="text-white/60 mb-4">
                Transformă operațiunile de parcare cu gestionare inteligentă a rezervărilor și analize în timp real.
              </p>
              
            </div>

            <div>
              <h4 className="text-white font-semibold mb-4">Produs</h4>
              <ul className="space-y-2 text-white/60">
                <li><button className="hover:text-white transition-colors" onClick={() => scrollToSection('features')}>Funcționalități</button></li>
                <li><button className="hover:text-white transition-colors" onClick={() => scrollToSection('pricing')}>Prețuri</button></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold mb-4">Companie</h4>
              <ul className="space-y-2 text-white/60">
                <li><button className="hover:text-white transition-colors" onClick={() => window.location.href = '/despre-noi.html'}>Despre Noi</button></li>
                <li><button className="hover:text-white transition-colors">Blog</button></li>
                <li><button className="hover:text-white transition-colors" onClick={() => setShowContactForm(true)}>Contact</button></li>
              </ul>
            </div>

            {/* <div>
              <h4 className="text-white font-semibold mb-4">Suport</h4>
              <ul className="space-y-2 text-white/60">
                <li><button className="hover:text-white transition-colors">Centru Ajutor</button></li>
                <li><button className="hover:text-white transition-colors">Documentație</button></li>
                <li><button className="hover:text-white transition-colors">Status Sistem</button></li>
                <li><button className="hover:text-white transition-colors">Securitate</button></li>
              </ul>
            </div> */}
          </div>

          <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-white/60 text-sm">
              © 2025 SoftParking. Toate drepturile rezervate.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <button className="text-white/60 hover:text-white transition-colors text-sm" onClick={() => window.location.href = '/politica.html'}>Politica de Confidențialitate</button>
              <button className="text-white/60 hover:text-white transition-colors text-sm" onClick={() => window.location.href = '/terms.html'}>Termeni și Condiții</button>
              <button className="text-white/60 hover:text-white transition-colors text-sm" onClick={() => window.location.href = '/cookie.html'}>Politica Cookie</button>
            </div>
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

function App() {
  return (
    <div className="App">
      <SoftParkingLanding />
    </div>
  );
}

export default App;